import { render } from "./Settings.vue?vue&type=template&id=741553bc"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=741553bc&lang=css"

import exportComponent from "C:\\Users\\Ray Wang\\Desktop\\tubertrader\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__